import React, { createContext, useContext, useState } from 'react';
import { setActiveCity, type City } from '../utils/activeCity';
interface CityContextValue {
  city: City;
  setCity: (city: City) => void;
}
const CityContext = createContext<CityContextValue>({
  city: 'Brossard',
  setCity: () => {}
});

/** The municipality currently administered — drives maps and sectors. */
export function CityProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [city, setCityState] = useState<City>('Brossard');
  setActiveCity(city);
  const setCity = (next: City) => {
    setActiveCity(next);
    setCityState(next);
  };
  return <CityContext.Provider value={{
    city,
    setCity
  }} data-id="element-6436" data-mp="9a5ebloa7t5f">{children}</CityContext.Provider>;
}
export function useCity() {
  return useContext(CityContext);
}